import React from 'react';

const YellowStripe = () => {
  const items = Array.from({ length: 14 });
  return (
    <div className="yellow-stripe">
      <div className="marquee">
        {items.map((_, i) => (
          <div
            key={`a-${i}`}
            className="flex items-center text-[#1a1a1a] font-heavy uppercase tracking-wider"
          >
            <span className="text-base md:text-lg">Content That Moves.</span>
          </div>
        ))}
        {items.map((_, i) => (
          <div
            key={`b-${i}`}
            className="flex items-center text-[#1a1a1a] font-heavy uppercase tracking-wider"
          >
            <span className="text-base md:text-lg">Content That Moves.</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default YellowStripe;
